import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
//import ImagePreview from "./ImagePreview";

const RegisterPage = () => {
  const requestedAccountType = new URLSearchParams(window.location.search).get("type");
  const [surnom, setSurnom] = useState("");
  const [email, setEmail] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [accountType, setAccountType] = useState(
    requestedAccountType === "professionnel" ? "professionnel" : "utilisateur"
  );
  const [telephone, setTelephone] = useState("");
  const [raisonSociale, setRaisonSociale] = useState("");
  const [siret, setSiret] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // Message d'erreur
  const [fieldErrors, setFieldErrors] = useState({});
  const navigate = useNavigate();

  const clearFieldError = (fieldName) => {
    setErrorMessage("");
    setFieldErrors((currentErrors) => {
      if (!currentErrors[fieldName]) return currentErrors;
      const nextErrors = { ...currentErrors };
      delete nextErrors[fieldName];
      return nextErrors;
    });
  };

  const validatePassword = (password) => {
    const minLength = 8;
    const maxLength = 20;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (
      password.length < minLength ||
      password.length > maxLength ||
      !hasUpperCase ||
      !hasLowerCase ||
      !hasNumber ||
      !hasSpecialChar
    ) {
      return false;
    }
    return true;
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setFieldErrors({});

    // Valider le mot de passe
    if (!validatePassword(motDePasse)) {
      setErrorMessage(
        "Le mot de passe doit contenir entre 8 et 20 caractères, inclure une majuscule, une minuscule, un chiffre et un caractère spécial."
      );
      return;
    }

    try {
      const formData = new FormData();
      formData.append("surnom", surnom);
      formData.append("email", email);
      formData.append("motDePasse", motDePasse);
      formData.append("accountType", accountType);
      if (accountType === "professionnel") {
        formData.append("telephone", telephone);
        formData.append("raisonSociale", raisonSociale);
        formData.append("siret", siret.replace(/\s/g, ""));
      }

      const apiBaseUrl = process.env.REACT_APP_URL_LOCAL;

      await axios.post(
        `${apiBaseUrl}/api/users/register`,
        formData
      );
      console.log("Registration successful!"); //console.log("Registration successful:", response.data);
      navigate("/login");
    } catch (error) {
      const responseData = error.response?.data;
      if (responseData?.error) {
        setFieldErrors(responseData.fieldErrors || {});
        setErrorMessage(responseData.error);
      } else {
        setErrorMessage(
          "Une erreur inattendue est survenue. Veuillez réessayer."
        );
      }
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-full max-w-lg rounded-lg border border-sky-500/20 bg-slate-950/70 p-8 text-white shadow-2xl shadow-sky-950/40">
        <h2 className="text-2xl font-bold mb-6">Inscription</h2>
        {errorMessage && (
          <div className="mb-4 p-3 text-red-700 bg-red-100 rounded">
            {errorMessage}
          </div>
        )}
        <form onSubmit={handleRegister}>
          <div className="mb-6 grid grid-cols-2 rounded-lg border border-sky-500/20 bg-slate-900/70 p-1">
            {[
              { value: "utilisateur", label: "Particulier" },
              { value: "professionnel", label: "Professionnel" },
            ].map((option) => (
              <button
                key={option.value}
                type="button"
                onClick={() => {
                  setAccountType(option.value);
                  setErrorMessage("");
                  setFieldErrors({});
                }}
                className={`rounded-md px-4 py-2 text-sm font-semibold transition ${
                  accountType === option.value
                    ? "bg-sky-600 text-white"
                    : "text-slate-400 hover:text-white"
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
          {accountType === "professionnel" && (
            <p className="mb-5 rounded-md border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 text-sm text-emerald-100">
              Votre espace professionnel sera entièrement actif pendant 7 jours, sans paiement.
            </p>
          )}
          <div className="mb-4">
            <label htmlFor="register-surnom" className="block text-gray-200">Surnom</label>
            <input
              id="register-surnom"
              type="text"
              className={`w-full px-3 py-2 border bg-black rounded ${
                fieldErrors.surnom
                  ? "border-red-500 hover:border-red-400"
                  : "border-sky-600 hover:border-sky-700"
              }`}
              value={surnom}
              onChange={(e) => {
                setSurnom(e.target.value);
                clearFieldError("surnom");
              }}
              aria-invalid={Boolean(fieldErrors.surnom)}
              aria-describedby={fieldErrors.surnom ? "surnom-error" : undefined}
              required
            />
            {fieldErrors.surnom && (
              <small id="surnom-error" className="text-xs text-red-300">
                {fieldErrors.surnom}
              </small>
            )}
          </div>
          {accountType === "professionnel" && (
            <>
              <div className="mb-4">
                <label htmlFor="register-telephone" className="block text-gray-200">Téléphone</label>
                <input
                  id="register-telephone"
                  type="tel"
                  className="w-full px-3 py-2 border hover:border-sky-700 border-sky-600 bg-black rounded"
                  value={telephone}
                  onChange={(e) => setTelephone(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label htmlFor="register-raison-sociale" className="block text-gray-200">Raison sociale</label>
                <input
                  id="register-raison-sociale"
                  type="text"
                  className="w-full px-3 py-2 border hover:border-sky-700 border-sky-600 bg-black rounded"
                  value={raisonSociale}
                  onChange={(e) => setRaisonSociale(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label htmlFor="register-siret" className="block text-gray-200">SIRET</label>
                <input
                  id="register-siret"
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9 ]{14,17}"
                  maxLength={17}
                  className={`w-full px-3 py-2 border bg-black rounded ${
                    fieldErrors.siret
                      ? "border-red-500 hover:border-red-400"
                      : "border-sky-600 hover:border-sky-700"
                  }`}
                  value={siret}
                  onChange={(e) => {
                    setSiret(e.target.value.replace(/[^0-9 ]/g, ""));
                    clearFieldError("siret");
                  }}
                  aria-invalid={Boolean(fieldErrors.siret)}
                  aria-describedby={fieldErrors.siret ? "siret-error" : "siret-help"}
                  required
                />
                {fieldErrors.siret ? (
                  <small id="siret-error" className="text-xs text-red-300">
                    {fieldErrors.siret}
                  </small>
                ) : (
                  <small id="siret-help" className="text-xs text-gray-400">14 chiffres</small>
                )}
              </div>
            </>
          )}
          <div className="mb-4">
            <label htmlFor="register-email" className="block text-gray-200">Email</label>
            <input
              id="register-email"
              type="email"
              className={`w-full px-3 py-2 border bg-black rounded ${
                fieldErrors.email
                  ? "border-red-500 hover:border-red-400"
                  : "border-sky-600 hover:border-sky-700"
              }`}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                clearFieldError("email");
              }}
              aria-invalid={Boolean(fieldErrors.email)}
              aria-describedby={fieldErrors.email ? "email-error" : undefined}
              required
            />
            {fieldErrors.email && (
              <small id="email-error" className="text-xs text-red-300">
                {fieldErrors.email}
              </small>
            )}
          </div>
          <div className="mb-4">
            <label htmlFor="register-password" className="block text-gray-200">Mot de Passe</label>
            <input
              id="register-password"
              type="password"
              className="w-full px-3 py-2 border hover:border-sky-700 border-sky-600 bg-black rounded"
              value={motDePasse}
              onChange={(e) => setMotDePasse(e.target.value)}
              required
            />
            <small className="text-xs text-gray-400">Le mot de passe doit contenir entre 8 et 20 caractères, inclure une majuscule, une minuscule, un chiffre et un caractère spécial.</small>
          </div>
          {/* <div className="mb-4">
            <label className="block text-gray-200">Photo de Profil</label>
            <ImagePreview onImageSelect={setImage} />
          </div> */}
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-sky-800 to-sky-700 hover:from-sky-900 hover:to-sky-950 text-white py-2 rounded font-bold"
          >
            S'inscrire
          </button>
        </form>
        <p className="mt-4 text-center">
          Vous avez déjà un compte ?{" "}
          <a href="/login" className="text-sky-600 hover:text-sky-700">
            Se connecter
          </a>
        </p>
        <p className="mt-2 text-center text-sm">
          <a href="/offres" className="text-slate-400 hover:text-sky-300">
            Comparer les offres et les droits
          </a>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
